import {  useState } from "react";
import "./projects.css";
import { useProject } from "../../providers/projectProvider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowDownLong,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import { AnimatePresence, motion } from "framer-motion";
import { Reveal } from "../Reveal";

export default function ProjectList() {
  const { projects, setCurrentProject } = useProject();
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [isHovered, setIsHovered] = useState(true);
  const [Hovered, setHovered] = useState(false);

  const handleHoverStart = () => {
    setIsHovered(true);
  };

  const handleHoverEnd = () => {
    setTimeout(() => {
      setIsHovered(false);
    }, 200);
  };

  const filteredProjects =
  selectedCategory === "All"
    ? [...projects].sort((a, b) => a.id - b.id)
    : projects
        .filter((project) => project.category === selectedCategory)
        .sort((a, b) => a.id - b.id);
  const handleProjectIndex = (projectId, index) => {
    const targetElement = document.getElementById(projectId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
      setCurrentProject(index);
    }
  };

  const getCategoryProjectCount = (category) => {
    return projects.filter((project) => project.category === category).length;
  };

  const categoryList = [
    "All",
    "Web Application",
    "Mobile Application",
    "Scripting & Automation",
  ];

  return (
    <div id="projects" className="mt-5 container">
      <Reveal widthClass={"w-fit"} revealSecondDiv={true}>
        <h1 className="about-heading">Work</h1>
      </Reveal>

      <div
        className="d-flex justify-content-start"
        style={{ gap: "10px", padding: "20px 0", flexWrap: "wrap" }}
      >
        {categoryList.map((item, index) => (
          <motion.div
            key={index}
            initial={{
              opacity: 0,
              x: -20,
            }}
            transition={{
              duration: 0.3,
              delay: index * 0.1,
            }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ amount: 0.5 }}
          >
            <button
              className="btn p-list-btn font-roobert"
              disabled={
                selectedCategory === item ||
                (item !== "All" && getCategoryProjectCount(item) === 0)
              }
              onClick={() => setSelectedCategory(item)}
            >
              {item} (
              {item === "All" ? projects.length : getCategoryProjectCount(item)}
              )
            </button>
          </motion.div>
        ))}
      </div>

      <div className="row d-flex project-list-row justify-content-center">
        {filteredProjects.map((item, index) => (
          <motion.div
            className={`${item.name} border-radius col-lg-6 col-md-6 col-sm-12 pb-4`}
            key={item.id}
          >
            <motion.div
              className="hover-work font-neue cursor-pointer"
              initial={{
                opacity: 0,
                x: -20,
              }}
              transition={{
                duration: 0.3,
                delay: index * 0.1,
              }}
              whileHover={{ scale: 1.05 }}
              whileInView={{ opacity: 1, x: 0 }}
              key={item.id}
              onClick={() => handleProjectIndex("projectPreview", item.id)}
              onMouseEnter={() => setHovered(item.id)}
              onMouseLeave={() => setHovered(null)}
            >
              <div className="work-image">
                <a href="#project-preview">
                  <motion.img
                    whileHover={{
                      filter: isHovered ? "blur(3px)" : "none",
                      scale: isHovered ? 1.04 : 1,
                      transition: { duration: 0.2 },
                    }}
                    onMouseEnter={handleHoverEnd}
                    onMouseLeave={handleHoverStart}
                    transition={{ duration: 0.1 }}
                    width="100%"
                    src={item.images[0]}
                  alt=""
                  />
                </a>
              </div>
              <div className="work-details">
                <p className="hide-project">{item.partDone.join(" • ")}</p>

                <h2 className="d-flex" style={{ gap: 10 }}>
                  <AnimatePresence>
                    {Hovered === item.id && (
                      <motion.div
                        initial={{ x: -40, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                      >
                        <FontAwesomeIcon icon={faArrowRight} size="xs" />
                      </motion.div>
                    )}
                  </AnimatePresence>
                  <motion.div
                    initial={{ x: 0, opacity: 1 }}
                    animate={{
                      x: Hovered === item.id ? 30 : 0,
                      opacity: Hovered === item.id ? 1 : 0.8,
                    }}
                  >
                    {item.name}
                  </motion.div>
                </h2>
                <p className="show-project"></p>
              </div>
            </motion.div>
          </motion.div>
        ))}
      </div>
      <div className="my-100">
        <a href="#projectPreview" className="text-white">
          {" "}
          <FontAwesomeIcon icon={faArrowDownLong} size="xl" />{" "}
        </a>
      </div>
    </div>
  );
}
